import type { ImgHTMLAttributes } from "react";
import {
  resolveVendiaAssetPath,
  vendiaAssetPaths,
  type VendiaLogoVariant,
  type VendiaProduct,
} from "../assets/paths";

type ProductLogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> & {
  product: Exclude<VendiaProduct, "master">;
  variant?: Exclude<VendiaLogoVariant, "dark">;
  assetBasePath?: string;
  alt?: string;
};

const productNames: Record<Exclude<VendiaProduct, "master">, string> = {
  quote: "Vendia Quote",
  pos: "Vendia POS",
  business: "Vendia Business",
};

export function VendiaProductLogo({
  product,
  variant = "horizontal",
  assetBasePath,
  alt = productNames[product],
  className,
  ...props
}: ProductLogoProps) {
  const path = vendiaAssetPaths[product].logo[variant] ?? vendiaAssetPaths[product].logo.horizontal;
  const src = resolveVendiaAssetPath(path, assetBasePath);
  const classes = [
    "vendia-logo",
    "vendia-product-logo",
    `vendia-product-logo--${product}`,
    `vendia-logo--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <img src={src} alt={alt} className={classes} {...props} />;
}
